const CardPayment = () => {
  return (
    <div>
      <p><strong>Note:</strong> You are making payment by card</p>
    </div>
  );
}

export default CardPayment;
